<div mat-dialog-content>
  <div class="text-center">
    <div class="i-circle danger">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <h4 class="color-default" [innerHtml]="text | translate" *ngIf="text"></h4>
  </div>
  <div [innerHtml]="subtext | safeHtml" *ngIf="subtext"></div>
<div *ngIf="form">
  <form [formGroup]="form" class="form-horizontal modal-dialog-custom">
    <div class="row">

      <!-- Campos Adicionais -->
      <div formArrayName="AdditionalFields">
        <div class="col-sm-12" *ngFor="let field of form.controls.AdditionalFields.controls; let i = index"
          [formGroupName]="i">
          <div class="form-group" *ngIf="field.get('Type') == 'Text'">
            <div class="col-sm-12">
              <mat-form-field class="full-width">
                <input matInput placeholder="{{field.get('Label').value|translate}}" formControlName="Value" />
              </mat-form-field>
            </div>
          </div>

          <div class="form-group" *ngIf="field.get('Type').value == 'List'">
            <div class="col-sm-12">
              <mat-form-field class="full-width">
                <mat-select placeholder="{{field.get('Label').value|translate}}"
                formControlName="Value">
                  <mat-option *ngFor="let value of field.get('List').value" [value]="value.ID">
                    {{value.Name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

    </div>
  </form>
</div>
  

</div>
<div mat-dialog-actions>
  <div class="full-width text-right">
    <button type="button" class="btn btn-danger" title="{{'BUTTON.CANCEL' | translate}}" (click)="close(false)">
      <i class="fas fa-times"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
    </button>
    <button type="button" class="btn btn-success" title="{{'BUTTON.CONFIRM' | translate}}" (click)="close(true)">
      <i class="fas fa-check"></i>&nbsp;{{'BUTTON.CONFIRM' | translate}}
    </button>
  </div>
</div>